import request from '@/axios/index.js'
const center = '/security/center/';
const staticapprove = '/user/staticapprove/';
const openinvoice = '/user/openinvoice/';
const pwd = '/pwd/';
export function getUserInfo(data,loading) {
    return request.axios({
        data:data,
        loading:loading,
        url: center+'getUserInfo'
    })
}
// 认证管理-静态认证详情
export function getApproveInfoByAprvId(data,loading) {
    return request.axios({
        data:data,
        loading:loading,
        url: staticapprove+'getApproveInfoByAprvId'
    })
}
export function getInvoiceInfo(data,loading) {
    return request.axios({
        data:data,
        loading:loading,
        url: openinvoice+'getOpenInvoiceInformationByCstId'
    })
}
export function updateInvoiceInfo(data,loading) {
    return request.axios({
        data:data,
        loading:loading,
        url: openinvoice+'updateOpenInvoiceInformation'
    })
}
export function queryApproveInfo(data,loading) {
    return request.axios({
        data:data,
        loading:loading,
        url: staticapprove+'get'
    })
}
export function temporary(data,loading=true) { // 认证信息保存
    return request.axios({
        data:data,
        loading:loading,
        url: staticapprove+'temporary'
    })
}
export function save(data,loading=true) { // 认证信息提交
    return request.axios({
        data:data,
        loading:loading,
        url: staticapprove+'save'
    })
}
export function checkUser(data,loading,success,fail) { //验证用户
    return request.axios({
        data:data,
        loading:loading,
        success:success,
        fai:fail,
        url: pwd+'checkUser'
    })
}
export function getCaptcha(data,loading,success,fail) { // 验证码
    return request.axios({
        data:data,
        loading:loading,
        success:success,
        fai:fail,
        url: '/captcha'
    })
}
//身份验证 - 手机/邮箱
export function checkMobile(data,loading,success,fail) {
    return request.axios({
        data:data,
        loading:loading,
        success:success,
        fai:fail,
        url: pwd+'checkMobile'
    })
}
// 修改登录、交易密码
export function setNewPwd(data,loading,success,fail) {
    return request.axios({
        data:data,
        loading:loading,
        success:success,
        fai:fail,
        url: pwd+'setNewPwd'
    })
}
// 修改密保手机
export function modifyMobile(data,loading,success,fail) {
    return request.axios({
        data:data,
        loading:loading,
        success:success,
        fai:fail,
        url: center+'modifyMobile'
    })
}
// 修改邮箱
export function modifyEmail(data,loading,success,fail) {
    return request.axios({
        data:data,
        loading:loading,
        success:success,
        fai:fail,
        url: center+'modifyEmail'
    })
}
// 获取操作人修改编号
export function getUserChangeApplyId(data,loading,success,fail) {
    return request.axios({
        data:data,
        loading:loading,
        success:success,
        fai:fail,
        url: center+'getUserChangeApplyId'
    })
}
// 修改管理员信息
export function setModifyUserInfo(data,loading,success,fail) {
    return request.axios({
        data:data,
        loading:loading,
        success:success,
        fai:fail,
        url: center+'modifyUserInfo'
    })
}

export function certificationSubmit(data,loading) {
    return request.axios({
        url: '/personal/certificationSubmit',
        data:data,
        loading:loading,
    })
}

export function getUserInfoApproveList(data,loading) {
    return request.axios({
        url: '/security/center/getUserInfoApproveList',
        data:data,
        loading:loading,
    })
}




// WEBPACK FOOTER //
// ./src/api/security.js